import React, { useState, useEffect, useContext } from 'react'
import classes from '../TrucksAvailable/TrucksAvailable.module.css'
import axios from '../../Axios'
import { Urls } from '../../Urls'
import { Activity, currentRequestTimeStamp } from '../../Constants'
import Loader from '../Loader'
import { toast } from 'react-toastify'
import classes1 from './chat.module.css'
import transport_alt from '../../Content/images/transporter_logo.png'
import mixpanel from 'mixpanel-browser'
import { useIndentTracking } from '../Indent/hooks/useIndentTracking'
import NewProfileModal from '../Shared/NewTransporterProfileModal/NewProfileModal'
import { UserApiContext } from '../UserDetailsContext/UserDetailsContext'

const Chat = ({
    item,
    type = '',
    screenName = "",
    moduleName = "",
    activityName = ""
}) => {
    const [message, setMessage] = useState("")
    const [messagelist, setMessagelist] = useState([])
    const [show, setShow] = useState(false)
    const [selectTransporter, setSelectTransporter] = useState("")
    const [selectTransporterName, setSelectTransporterName] = useState("")
    const [activeTransporter, setActiveTransporter] = useState({ id: "", name: "" })
    const [openProfileModal, setOpenProfileModal] = useState(false)
    const { userDetails } = useContext(UserApiContext);

    const handleOpenProfile = (e, transporter) => {
        e.stopPropagation()
        setActiveTransporter({
            id: transporter.transporter_id,
            name: transporter.transporter_name,
        })
        setOpenProfileModal(true)
    }

    const handleCloseModal = () => {
        setOpenProfileModal(false)
        setActiveTransporter({ id: "", name: "" })
    }

    const { trackIndentEvent } = useIndentTracking()

    useEffect(() => {
        Activity([{ "screen": screenName, "module": moduleName, "user_activity": activityName, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])

        trackIndentEvent("indent request", "user has opened indent chat", `type : ${type}, indent id: ${item.display_indent_id}`)

        if (type === 'indent') {
            getIndentChats()
        }
    }, [])

    const getIndentChats = () => {
        setShow(true)
        axios.get(`${Urls.indent_chat}&indent_id=${item.indent_id}`)
            .then(res => {
                setShow(false)
                var tl = []
                if (res.data && res.data.length > 0) {
                    res.data.map(mssg => {
                        if (mssg.indent_id === item.indent_id) {
                            setMessagelist(mssg.message_list)
                            mssg.message_list.map((ml) => {
                                tl.push(ml.transporter_id);
                            })
                            setSelectTransporter(mssg.message_list[0].transporter_id)
                            setSelectTransporterName(mssg.message_list[0].transporter_name)
                            if (mssg.message_list[0].read_status === false) {
                                axios.post(`${Urls.indent_chat}&transporter_id=${mssg.message_list[0].transporter_id}&indent_id=${item.indent_id}&update_type=transporter`,
                                    {
                                        transporter_id: mssg.message_list[0].transporter_id,
                                        read_status: true,
                                        transporter_name: mssg.message_list[0].transporter_name
                                    })
                                    .then(res => {
                                    })
                                    .catch(e => console.log(e))
                            }
                        }
                    })
                } else {
                    if (messagelist.length <= 0) {
                        var message_list = []
                        item.indent_info.shortlisted_transporters.map((transporter) => {
                            var mssg = {
                                "transporter_id": transporter.transporter_id,
                                "read_status": false,
                                "transporter_name": transporter.transporter_name,
                                "message_values": []
                            }
                            message_list.push(mssg)
                        })
                        var payload = {
                            "indent_id": item.indent_id,
                            "module_key": "indent",
                            "email": userDetails.email,
                            "message_list": message_list
                        }
                        axios.post(`${Urls.indent_chat}&transporter_id=${selectTransporter}&indent_id=${item.indent_id}`, payload)
                            .then(res => {
                                toast.success(res);
                            })
                            .catch(e => {
                                console.log(e)
                                toast.info('RequestFailed')
                            })
                        setMessagelist(message_list)
                        setSelectTransporter(item.indent_info.shortlisted_transporters[0].transporter_id)
                    }
                }
            }).catch(e => {
                setShow(false)
                console.log(e)
            })

    }


    const date_conversion_enquiry = (dateinput) => {
        var date_considered = new Date(dateinput);
        var dd = date_considered.getDate();
        var mm = date_considered.getMonth() + 1;
        var yyyy = date_considered.getFullYear();
        var hours = date_considered.getHours();
        var minutes = date_considered.getMinutes();
        var month_name = new Array();
        month_name[1] = "Jan";
        month_name[2] = "Feb";
        month_name[3] = "Mar";
        month_name[4] = "Apr";
        month_name[5] = "May";
        month_name[6] = "Jun";
        month_name[7] = "Jul";
        month_name[8] = "Aug";
        month_name[9] = "Sep";
        month_name[10] = "Oct";
        month_name[11] = "Nov";
        month_name[12] = "Dec";
        var name_month = month_name[mm];
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        if (hours < 10) {
            hours = '0' + hours;
        }
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        date_considered = `${name_month}${" "}${dd}, ${yyyy}${" "}${hours}:${minutes}`
        return date_considered
    }

    const imageFallBack = e => {
        e.target.src = transport_alt;
    };

    const sendMessage = () => {
        Activity([{ "screen": screenName, "module": moduleName, "user_activity": 'Message Sent button clicked', "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname:userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])
        mixpanel.track(`User has clicked on send message button`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: `${screenName}`,
            ModuleName: `${moduleName}`,
            ActivityLog: 'userClickedSendMessageButton',
            Data: `${activityName}`,
            Definition: `User has clicked on send message button`,
            ActivityType: 'event_view',
            UserName: userDetails.user_name,
            UserEmail: userDetails.email,
            CompanyName: userDetails.company_name
                ? userDetails.company_name
                : userDetails.email
                    ? userDetails.email.split("@")[1].split(".")[0]
                    : ""
        });
        if (selectTransporter === 'all') {
            var mssg = messagelist.slice()
            mssg.map((m) => {
                var mlist = m.message_values
                mlist.push({
                    'datetime': currentRequestTimeStamp(),
                    'message': message,
                    "unread_status": false,
                    'user_type': 'company_user'
                })
            })
            var msglist = mssg.map((m) => {
                return {
                    "transporter_id": m.transporter_id,
                    "read_status": false,
                    "transporter_name": m.transporter_name,
                    "message_values": [
                        {
                            "datetime": currentRequestTimeStamp(),
                            "message": message,
                            "unread_status": false,
                            "user_type": "company_user"
                        }

                    ]
                }
            })
            // console.log({'message_list':msglist})
            var payload = { 'message_list': msglist }
            setShow(true)
            if (type === 'indent') {
                axios.post(`${Urls.indent_chat}&indent_id=${item.indent_id}&send_multiple=true`, payload)
                    .then(res => {
                        setShow(false)
                        document.getElementById("message").value = ""
                        setMessage('')
                    }).catch(e => console.log(e))
            }
        } else {
            var mssg = messagelist.slice()
            mssg = mssg.map(m => {
                if (m.transporter_id === selectTransporter) {
                    var mlist = m.message_values
                    mlist.push({
                        'datetime': currentRequestTimeStamp(),
                        'message': message,
                        "unread_status": false,
                        'user_type': 'company_user'
                    })
                }
                return m
            })
            setMessagelist(mssg)

            var payload = {
                "transporter_id": selectTransporter,
                "read_status": false,
                "transporter_name": selectTransporterName,
                "message_values": [
                    {
                        "datetime": currentRequestTimeStamp(),
                        "message": message,
                        "unread_status": false,
                        "user_type": "company_user"
                    }

                ]
            }
            setShow(true)
            if (type === 'indent') {
                axios.post(`${Urls.indent_chat}&transporter_id=${selectTransporter}&indent_id=${item.indent_id}`, payload)
                    .then(res => {
                        setShow(false)
                        document.getElementById("message").value = ""
                        setMessage('')
                    }).catch(e => console.log(e))
            }
        }
    }

    const changeHandler = (ml) => {
        Activity([{ "screen": screenName, "module": moduleName, "user_activity": `${ml.transporter_name} button clicked`, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])
        mixpanel.track(`User has clicked on broadcast to all button`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: `${screenName}`,
            ModuleName: `${moduleName}`,
            ActivityLog: 'userClickedBroadcastToAllButton',
            Data: `${activityName}`,
            Definition: `User has clicked on broadcast to all button`,
            ActivityType: 'event_view',
            UserName: userDetails.user_name,
            UserEmail: userDetails.email,
            CompanyName: userDetails.company_name
                ? userDetails.company_name
                : userDetails.email
                    ? userDetails.email.split("@")[1].split(".")[0]
                    : ""
        });
        setSelectTransporter(ml.transporter_id)
        setSelectTransporterName(ml.transporter_name)
        if (ml !== 'all') {
            if (type === 'indent') {
                axios.post(`${Urls.indent_chat}&transporter_id=${ml.transporter_id}&indent_id=${item.indent_id}&update_type=transporter`,
                    {
                        transporter_id: ml.transporter_id,
                        read_status: true,
                        transporter_name: ml.transporter_name
                    })
                    .then(res => {
                        // console.log(res)
                    })
                    .catch(e => console.log(e))
            }
            ml.transporter_unread_count = 0
        } else {
            setSelectTransporter('all')
            setSelectTransporterName('all')
        }
    }
    const getImageSrc = (logo) => {
        if (logo)
            // return `https://lorrifilesproduction.blob.core.windows.net/public-container/${logo}`
            return `${Urls.showlogo}/${logo}`
        return transport_alt
    }
    const HandleKeyDown = (e) => {
        const messageInput = document.getElementById('message');

        if (e.key === 'Enter' && e.shiftKey) {
            e.preventDefault();
            const cursorPosition = messageInput.selectionStart;
            const newValue =
                messageInput.value.substring(0, cursorPosition) +
                '\n' +
                messageInput.value.substring(cursorPosition);
            messageInput.value = newValue;
            messageInput.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
        } else if (e.key === 'Enter' && !e.altKey) {
            e.preventDefault();
            const trimmedMessage = messageInput.value.trim();
            if (trimmedMessage) {
                // Append the trimmed message to the existing message state with a newline
                setMessage((prevMessage) => prevMessage + trimmedMessage + '\n');
                messageInput.value = ''; // Clear the message input after sending
                sendMessage(); // Call your sendMessage function
            }
        }
    };


    return (
        <>
            {show ? <Loader show={show} /> :
                <div className="row" style={{ overflowX: 'hidden', margin: 0 }}>
                    {messagelist && messagelist.length > 0 ?
                        <>

                            <div className={`col-12 col-md-4 ${classes['tr-list']}`}>
                                <div className={classes1['tr-list-inner']}>
                                    <div>
                                        <div onClick={e => changeHandler('all')}
                                            style={{ height: '7vh', color: '#393186', fontWeight: '600', padding: '5%' }}
                                            className={selectTransporter === 'all' ? classes1['tr-namess'] : classes1['tr-names']}>
                                            <span>Broadcast to All</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            style={{ height: '7vh', color: '#393186', fontWeight: '600', padding: '5%' }}
                                            className={classes1['only-names']}>
                                            <span>Send Message to Transporters</span>
                                        </div>
                                    </div>
                                    {messagelist.map((ml, index) => {
                                        return (
                                            <div key={index} onClick={e => changeHandler(ml)}
                                                className={ml.transporter_id === selectTransporter ? classes1['tr-namess'] : classes1['tr-names']}>
                                                {ml.transporter_unread_count && ml.transporter_unread_count !== 0 ?
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className={`${classes['avatar-circle']}`}>
                                                                <img className={`${classes['s-a']}`} src={getImageSrc(ml)} onError={e => imageFallBack(e)} />
                                                            </div>
                                                        </div>
                                                        <div className={`col-md-9 ${classes1['myborder']}`}>
                                                            <span
                                                                style={{ color: '#54af3a', fontSize: '13px', cursor: 'pointer', textDecoration: 'underline' }}
                                                                onClick={(e) => handleOpenProfile(e, ml)}
                                                                title="View Transporter Profile"
                                                            >
                                                                {ml.transporter_name && ml.transporter_name.length < 25 ? ml.transporter_name.toUpperCase() : `${(ml.transporter_name.toUpperCase()).substring(0, 25)}...`}
                                                            </span>
                                                            <span className={`${classes1['chat_number']}`}>{ml.transporter_unread_count}</span>
                                                            <div style={{ height: '17px', fontSize: '11px', overflow: 'hidden' }}>{ml.message_values && ml.message_values.length > 0 ? ml.message_values[ml.message_values.length - 1].message.length < 15 ? ml.message_values[ml.message_values.length - 1].message : `${(ml.message_values[ml.message_values.length - 1].message).substring(0, 15)}...` : null}</div>
                                                        </div>
                                                    </div> :
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className={`${classes['avatar-circle']}`}>
                                                                <img className={`${classes['s-a']}`} src={getImageSrc(ml.logo)} onError={e => imageFallBack(e)} />
                                                            </div>
                                                        </div>
                                                        <div className={`col-md-9 ${classes1['myborder']}`}>
                                                            <span
                                                                style={{ fontSize: '13px', cursor: 'pointer', textDecoration: 'underline' }}
                                                                onClick={(e) => handleOpenProfile(e, ml)}
                                                                title="View Transporter Profile"
                                                            >
                                                                {ml.transporter_name && ml.transporter_name.length < 25 ? ml.transporter_name.toUpperCase() : `${(ml.transporter_name.toUpperCase()).substring(0, 25)}...`}
                                                            </span>
                                                            <div style={{ height: '17px', fontSize: '11px', overflow: 'hidden' }}>{ml.message_values && ml.message_values.length > 0 ? ml.message_values[ml.message_values.length - 1].message.length < 15 ? ml.message_values[ml.message_values.length - 1].message : `${(ml.message_values[ml.message_values.length - 1].message).substring(0, 15)}...` : null}</div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                        )
                                    })}
                                </div>
                            </div>
                            <div className={`col-12 col-md-7 ${classes['tr-chat']}`}>
                                {selectTransporter === 'all' ? 'Send Message to all Shortlisted Transporter' : null}
                                {messagelist.map((ml, index) => {
                                    if (ml.transporter_id === selectTransporter) {
                                        var msgvalues = ml.message_values.map((msg, index) => {
                                            return (
                                                <div key={index} className={msg.user_type === "transporter" ? classes1['s-chat-list-left'] : classes1['s-chat-list']}>
                                                    {msg.message.split('\n').map((messageLine, index) => (
                                                        <span key={index} style={{ margin: '4%', wordWrap: 'break-word' }}>{messageLine}<br /></span>
                                                    ))}
                                                    <span style={{ float: 'right', fontStyle: 'italic', marginRight: '1%', fontSize: '11px' }}>{date_conversion_enquiry(msg.datetime)}</span>
                                                </div>
                                            )
                                        })
                                        return (
                                            <>
                                                <span
                                                    style={{ cursor: "pointer", color: "#393186", fontWeight: "bold", textDecoration: "underline" }}
                                                    onClick={(e) => handleOpenProfile(e, ml)}
                                                    title="View Transporter Profile"
                                                >
                                                    {ml.transporter_name.toUpperCase()}
                                                </span>
                                                <div className={classes['s-chat']}>{msgvalues && msgvalues.length > 0 ? msgvalues : "Please Add Messages"}</div>
                                            </>
                                        )
                                    }
                                })}
                                <div className={classes['s-div-inputs']}>
                                    <div className={`form-group ${classes['chat-input']}`} style={{ display: 'flex', marginTop: '1%', flexWrap: 'nowrap', alignItems: 'flex-end', gap: '4px' }}>
                                        <textarea style={{ minHeight: '65px', height: 'auto', flex: 1, minWidth: 0 }} rows="2" className={`${classes['s-message']}`}
                                            placeholder="Type a message" id="message" onChange={event => setMessage(event.target.value)} onKeyDown={e => HandleKeyDown(e)}
                                        />
                                        <button disabled={message !== '' && message !== null ? false : true} onClick={e => sendMessage()} className={`btn btn-sm btn-primary ${classes['s-sent']}`} style={{ flexShrink: 0 }}><i className="fa fa-paper-plane" /></button>
                                    </div>
                                </div>

                            </div>
                        </>
                        : <div style={{ justifyContent: 'center', width: '100%' }}><center>No Enquiry received</center></div>}
                </div>}
            {openProfileModal && activeTransporter?.id !== "" && (
                <NewProfileModal
                    isOpen={openProfileModal}
                    onClose={handleCloseModal}
                    transporter_id={activeTransporter.id}
                    transporter_name={activeTransporter.name}
                    screenName={"LoRRI Adhoc"}
                    moduleName={"My Enquiries"}
                    transporter_list={messagelist}
                />
            )}
        </>
    )
}

export default Chat
